import WasmController from "react-lib/frameworks/WasmController";

// Interface
import { State as MainState } from "../../../../../HIS/MainHISInterface";

// Common
import { SetProperty } from "../../common/CommonInterface";
// import moment from "moment";

// Utils
import { beStringToAdString } from "react-lib/utils/dateUtils";

// Serializer
import LeaveTypeSerializer from "issara-sdk/types/LeaveTypeSerializer_apps_HRM";
import LeaveRequestActionSerializer from "issara-sdk/types/LeaveRequestActionSerializer_apps_HRM";
import WorkShiftTemplateSerializer from "issara-sdk/types/WorkShiftTemplateSerializer_apps_HRM";
import { LeaveRequestListType } from "../LeaveRequestListRendering";

// API
import LeaveTypeList from "issara-sdk/apis/LeaveTypeList_apps_HRM";
import LeaveRequestList from "issara-sdk/apis/LeaveRequestList_apps_HRM";
import LeaveRequestActionList from "issara-sdk/apis/LeaveRequestActionList_apps_HRM";
import WorkShiftTemplateList from "issara-sdk/apis/WorkShiftTemplateList_apps_HRM";
import WorkShiftTemplateDetail from "issara-sdk/apis/WorkShiftTemplateDetail_apps_HRM";

import { ADMIN_TAB_LIST } from "react-lib/apps/USER/CardSettingDivision";

export type State = Partial<{
  // seq
  WorkScheduleSequence: Partial<{
    sequenceIndex: "Start" | "Action" | null;
    setupWorkSchedule: any; // * (Tab 1) --- เรียกใช้ที่ SetupWorkSchedule
    setupWorkShiftsTemplate: SetupWorkShiftsTemplateType; // * (Tab 2)
    employeeAttendance: any; // * (Tab 3) --- เรียกใช้ที่ EmployeeTA
    employeeLeaveRequest: EmployeeLeaveRequestType; // * (Tab 4)
    summaryWork: any; // * (Tab 5) ยังไม่สร้าง Type
  }> | null;
}>;

export type SetupWorkShiftsTemplateType = Partial<{
  filter: Partial<{ code_name: string; exclude_inactive: boolean; }>;
  pagination: {
    activePage: number;
    items: WorkShiftTemplateSerializer[];
    total: number;
  };
  templateList: WorkShiftTemplateSerializer[];
}>;

export type EmployeeLeaveRequestType = Partial<{
  filter: EmployeeLeaveRequestFilterType;
  leaveTypeList: LeaveTypeSerializer[];
  leaveRequestList: LeaveRequestListType[];
  pagination: {
    activePage: number;
    items: LeaveRequestListType[];
    total: number;
  };
}>;

export type EmployeeLeaveRequestFilterType = Partial<{
  affiliate: number;
  affiliate_list: number[];
  employee_list: number;
  start_date: string; // * format dd/mm/yyyy (AD)
  end_date: string; // * format dd/mm/yyyy (AD)
}>;

export type ShiftTimeSaveType = {
  id: number;
  leave_start_time: string;
  leave_end_time: string;
};

// todo --- ปรับการเรียก Sequence ตามราย Menu

export type Props = {};

type PickedState = Partial<
  Pick<
    MainState,
    | "adminMenuDivisions"
    | "buttonLoadCheck"
    | "errorMessage"
    | "masterOptions"
    | "searchedItemListWithKey"
    | "selectedDivision"
    | "successMessage"
  >
>;

export type PickedProps = Partial<Omit<PickedState, "">>;

// Sequence
type SeqState = {
  sequence: "WorkSchedule";
  restart?: boolean;
  clear?: boolean;
};

// Action
// type ActionType =
//   | { action: "SetupSchedule"; }
//   | { action: "SetupShiftsTemplate"; }
//   | { action: "Attendance"; }
//   | { action: "LeaveRequest"; }
//   | { action: "Summary"; };

type MenuActionMap = {
  SetupSchedule: { action: "FETCH" };
  SetupShiftsTemplate:
    | { action: "FETCH"; activePage?: number }
    | {
        action: "SAVE";
        saveTemplate: Partial<WorkShiftTemplateSerializer>;
      }
    | {
        action: "EDIT";
        templateId: number;
        editTemplate: Partial<WorkShiftTemplateSerializer>;
      }
    | { action: "DELETE"; templateId: number };
  Attendance: { action: "FETCH" };
  LeaveRequest:
    | {
        action: "FETCH";
        filter?: EmployeeLeaveRequestFilterType;
        activePage?: number;
      }
    | {
        action: "APPROVAL";
        requestId: number;
        status: "A" | "X" | "P" | "U" | undefined;
        remark?: string;
        work_shift?: ShiftTimeSaveType[];
        activePage?: number;
      };
  Summary: { action: "FETCH" };
};

type MenuType = {
  [K in keyof MenuActionMap]: { menu: K } & MenuActionMap[K];
}[keyof MenuActionMap];

export type RunSequence = <M extends keyof MenuActionMap | undefined = undefined>(
  params: M extends keyof MenuActionMap ? SeqState & { menu: M } & MenuActionMap[M] : SeqState
) => void;

export type SetProp = SetProperty<State & PickedState>;

type ExtractAction<
  M extends keyof MenuActionMap,
  A extends MenuActionMap[M] extends { action: string } ? MenuActionMap[M]["action"] : never
> = { menu: M } & Extract<MenuActionMap[M], { action: A }>;

// type SeqAct = ActionType & SeqState;

// type SeqType<K> = K extends { action: string } ? Extract<SeqAct, K> : SeqState;

// export type RunSequence = <K extends keyof SeqAct>(params: SeqType<Pick<SeqAct, K>>) => void;

// export type SetProp = SetProperty<State & PickedState>;

// type CustomExtract<T, U> = T extends object ? (U extends Partial<T> ? T : never) : never;

// type Params<A extends ActionType["action"]> = CustomExtract<ActionType, { action: A }>;

export const StateInitial: State & PickedState = {
  // seq
  WorkScheduleSequence: {
    sequenceIndex: null,
  },
  // SnackMessage
  successMessage: null,
  errorMessage: null,
};

export type Event =
  | { message: "RunSequence"; params: {} }
  | { message: "GetMasterData"; params: {} };

export type Data = {
  division?: number;
  useProfile?: Record<string, any>;
};

export const DataInitial = {};

export const CARD_NAME = "CardWordSchedule";

type Optional<T> = {
  [K in keyof T]: `${typeof CARD_NAME}_${T[K] & string}`;
};

export const MENUS = {
  SetupSchedule: ["FETCH"],
  SetupShiftsTemplate: ["FETCH", "SAVE", "EDIT", "DELETE"],
  Attendance: ["FETCH"],
  LeaveRequest: ["FETCH", "APPROVAL"],
  Summary: ["FETCH"],
} as const;

export const BTN_ACTS = Object.fromEntries(
  Object.entries(MENUS).map(([menu, actions]) => [
    menu,
    Object.fromEntries(actions.map((action) => [action, `${CARD_NAME}_${menu}_${action}`])),
  ])
) as {
  [M in keyof typeof MENUS]: {
    [A in (typeof MENUS)[M][number]]: `${typeof CARD_NAME}_${M}_${A}`;
  };
};

type Handler<P = any, R = any> = (
  controller: WasmController<State & PickedState, Event, Data, Props>,
  params: P
) => R;

export type TabMenu =
  | "Attendance"
  | "EmployeeTraining"
  | "LeaveRequest"
  | "SetupSchedule"
  | "SetupShiftsTemplate"
  | "Summary"
  | "TrainingManagement";

const Masters = [
  ["leaveType", {}],
  ["division", {}],
] as const;

export const DEFAULT_LIMIT = 20;

const BLC = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
} as const;

export const TAB_MENU_MAPPING = {
  // Set up Work Schedule
  [ADMIN_TAB_LIST["Set up Work Schedule"]]: "SetupSchedule",
  // Set up Work Shift template
  [ADMIN_TAB_LIST["Set up Work Shift template"]]: "SetupShiftsTemplate",
  // Employee Attendance
  [ADMIN_TAB_LIST["Employee Attendance"]]: "Attendance",
  // Employee Leave Request
  [ADMIN_TAB_LIST["Employee Leave Request"]]: "LeaveRequest",
  // Employee Training
  [ADMIN_TAB_LIST["Employee Training"]]: "EmployeeTraining",
  // Training Management
  [ADMIN_TAB_LIST["Training Management"]]: "TrainingManagement",
  // Summary Work Hour/Month
  [ADMIN_TAB_LIST["Summary Work Hour/Month"]]: "Summary",
} as const;

/**========================================================================
 **                               START
 *========================================================================**/

export const Start: Handler<SeqState> = async (controller, params) => {
  const state = controller.getState();

  controller.handleEvent({ message: "GetMasterData", params: { masters: Masters } });

  // const [leaveTypeResp, leaveTypeErr] = await GetLeaveTypeList(controller, params);

  controller.setState(
    {
      WorkScheduleSequence: {
        ...state.WorkScheduleSequence,
        sequenceIndex: "Action",
        employeeLeaveRequest: {
          ...state.WorkScheduleSequence?.employeeLeaveRequest,
          // leaveTypeList: leaveTypeResp?.items,
        },
      },
    },
    () => Action(controller, { ...params, menu: "SetupSchedule", action: "FETCH" })
  );
};

/**========================================================================
 **                              ACTIONS
 *========================================================================**/
export const Action: Handler<MenuType> = async (controller, params) => {
  const actionHandlers = {
    SetupSchedule: {
      FETCH: HandleSetupSchedule,
    },
    SetupShiftsTemplate: {
      FETCH: HandleSetupShiftsTemplate,
      SAVE: HandleSaveShiftsTemplate,
      EDIT: HandleEditShiftsTemplate,
      DELETE: HandleDeleteShiftsTemplate,
    },
    Attendance: {
      FETCH: HandleEmployeeAttendance,
    },
    LeaveRequest: {
      FETCH: HandleEmployeeLeaveRequest,
      APPROVAL: HandleEmployeeLeaveRequestApproval,
    },
    Summary: {
      FETCH: HandleSummaryWork,
    },
  } as any;

  const { menu, action } = params as any;

  const handler = actionHandlers?.[menu]?.[action];

  if (handler) {
    return handler(controller, params as any);
  }
};

/**========================================================================
 **                          Setup Schedule Menu
 *========================================================================**/

const HandleSetupSchedule: Handler<ExtractAction<"SetupSchedule", "FETCH">> = async (
  controller,
  params
) => {
  const state = controller.getState();
};

/**========================================================================
 **                      Setup Shifts Template Menu
 *========================================================================**/

const HandleSetupShiftsTemplate: Handler<ExtractAction<"SetupShiftsTemplate", "FETCH">> = async (
  controller,
  params
) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.SetupShiftsTemplate.FETCH]: BLC.LOADING,
    },
  });

  const filter = state.WorkScheduleSequence?.setupWorkShiftsTemplate?.filter ?? {};
  const activePage = params.activePage ?? 1;
  const offset = (activePage - 1) * DEFAULT_LIMIT;

  const [listResp, listErr] = await GetWorkShiftsTemplateList(controller, {
    active_only: !filter.exclude_inactive,
    code_name: filter.code_name,
    limit: DEFAULT_LIMIT,
    offset,
  });

  if (listErr) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [BTN_ACTS.SetupShiftsTemplate.FETCH]: BLC.ERROR,
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: listErr,
      },
    });

    return;
  }

  controller.setState({
    WorkScheduleSequence: {
      ...state.WorkScheduleSequence,
      setupWorkShiftsTemplate: {
        ...state.WorkScheduleSequence?.setupWorkShiftsTemplate,
        pagination: {
          activePage,
          items: listResp?.items || [],
          total: listResp?.total || 0,
        },
        templateList: listResp?.items || [],
      },
    },
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.SetupShiftsTemplate.FETCH]: BLC.SUCCESS,
    },
  });
};

const HandleSaveShiftsTemplate: Handler<ExtractAction<"SetupShiftsTemplate", "SAVE">> = async (
  controller,
  params
) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.SetupShiftsTemplate.SAVE]: BLC.LOADING,
    },
  });

  const { saveTemplate } = params;
  const pagination = state.WorkScheduleSequence?.setupWorkShiftsTemplate?.pagination;

  const [saveResp, saveErr] = await SaveWorkShiftsTemplate(controller, { saveTemplate });

  if (saveErr) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [BTN_ACTS.SetupShiftsTemplate.SAVE]: BLC.ERROR,
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: saveErr,
      },
    });

    return;
  }

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.SetupShiftsTemplate.SAVE]: BLC.SUCCESS,
    },
    successMessage: {
      ...state.successMessage,
      [CARD_NAME]: "Save Work Shifts Template Success",
    },
  });

  HandleSetupShiftsTemplate(controller, {
    ...params,
    action: "FETCH",
    activePage: pagination?.activePage,
  });
};

const HandleEditShiftsTemplate: Handler<ExtractAction<"SetupShiftsTemplate", "EDIT">> = async (
  controller,
  params
) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.SetupShiftsTemplate.EDIT]: BLC.LOADING,
    },
  });

  const { templateId, editTemplate } = params;
  const pagination = state.WorkScheduleSequence?.setupWorkShiftsTemplate?.pagination;

  const [editResp, editErr] = await EditWorkShiftsTemplate(controller, {
    templateId,
    editTemplate,
  });

  if (editErr) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [BTN_ACTS.SetupShiftsTemplate.EDIT]: BLC.ERROR,
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: editErr,
      },
    });

    return;
  }

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.SetupShiftsTemplate.EDIT]: BLC.SUCCESS,
    },
    successMessage: {
      ...state.successMessage,
      [CARD_NAME]: "Edit Work Shifts Template Success",
    },
  });

  HandleSetupShiftsTemplate(controller, {
    ...params,
    action: "FETCH",
    activePage: pagination?.activePage,
  });
};

const HandleDeleteShiftsTemplate: Handler<ExtractAction<"SetupShiftsTemplate", "DELETE">> = async (
  controller,
  params
) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.SetupShiftsTemplate.DELETE]: BLC.LOADING,
    },
  });

  const { templateId } = params;
  const pagination = state.WorkScheduleSequence?.setupWorkShiftsTemplate?.pagination;

  const [delResp, delErr] = await DeleteWorkShiftsTemplate(controller, { templateId });

  if (delErr) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [BTN_ACTS.SetupShiftsTemplate.DELETE]: BLC.ERROR,
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: delErr,
      },
    });

    return;
  }

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.SetupShiftsTemplate.DELETE]: BLC.SUCCESS,
    },
    successMessage: {
      ...state.successMessage,
      [CARD_NAME]: "Delete Work Shifts Template Success",
    },
  });

  HandleSetupShiftsTemplate(controller, {
    ...params,
    action: "FETCH",
    activePage: pagination?.activePage,
  });
};

/**========================================================================
 **                        Employee Attendance Menu
 *========================================================================**/

const HandleEmployeeAttendance: Handler<ExtractAction<"Attendance", "FETCH">> = async (
  controller,
  params
) => {
  const state = controller.getState();
};

/**========================================================================
 **                      Employee Leave Request Menu
 *========================================================================**/

const HandleEmployeeLeaveRequest: Handler<ExtractAction<"LeaveRequest", "FETCH">> = async (
  controller,
  params
) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.LeaveRequest.FETCH]: "LOADING",
    },
  });

  const { filter } = params;

  const filterFormatted: EmployeeLeaveRequestFilterType = {
    end_date: beStringToAdString(filter?.end_date || ""),
    start_date: beStringToAdString(filter?.start_date || ""),
    ...(filter?.affiliate
      ? { affiliate_list: filter.affiliate }
      : { affiliate_list: filter?.affiliate_list }),
    ...(filter?.employee_list && { employee_list: filter.employee_list }),
  };

  const activePage = params.activePage ?? 1;
  const offset = (activePage - 1) * DEFAULT_LIMIT;

  const [requestResp, requestErr] = await GetLeaveRequestList(controller, {
    filter: filterFormatted,
    limit: DEFAULT_LIMIT,
    offset,
  });

  if (requestErr) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [BTN_ACTS.LeaveRequest.FETCH]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: requestErr,
      },
    });

    return;
  }

  controller.setState({
    WorkScheduleSequence: {
      ...state.WorkScheduleSequence,
      employeeLeaveRequest: {
        ...state.WorkScheduleSequence?.employeeLeaveRequest,
        filter,
        leaveRequestList: requestResp?.items,
        pagination: {
          activePage,
          items: requestResp?.items || [],
          total: requestResp?.total || 0,
        },
      },
    },
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.LeaveRequest.FETCH]: "SUCCESS",
    },
  });
};

const HandleEmployeeLeaveRequestApproval: Handler<
  ExtractAction<"LeaveRequest", "APPROVAL">
> = async (controller, params) => {
  const state = controller.getState();

  const { requestId, status, remark, work_shift } = params;
  const activePage = params.activePage || 1;
  const filter = state.WorkScheduleSequence?.employeeLeaveRequest?.filter;
  const pagination = state.WorkScheduleSequence?.employeeLeaveRequest?.pagination;

  const data: Partial<LeaveRequestActionSerializer> = {
    status,
    ...(remark && { reject_remark: remark }),
    ...(work_shift && { work_shift }),
  };

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [`${BTN_ACTS.LeaveRequest.APPROVAL}_${requestId}`]: "LOADING",
    },
  });

  const [, approvalErr] = await ApprovalLeaveRequest(controller, { requestId, data });

  if (approvalErr) {
    controller.setState({
      WorkScheduleSequence: {
        ...state.WorkScheduleSequence,
        employeeLeaveRequest: {
          ...state.WorkScheduleSequence?.employeeLeaveRequest,
          filter,
          pagination: {
            ...pagination,
            activePage,
            items: pagination?.items || [],
            total: pagination?.total || 0,
          },
        },
      },
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${BTN_ACTS.LeaveRequest.APPROVAL}_${requestId}`]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: approvalErr,
      },
    });

    return;
  }

  controller.setState({
    // WorkScheduleSequence: {
    //   ...state.WorkScheduleSequence,
    //   employeeLeaveRequest: {
    //     ...state.WorkScheduleSequence?.employeeLeaveRequest,
    //   }
    // },
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [`${BTN_ACTS.LeaveRequest.APPROVAL}_${requestId}`]: "SUCCESS",
    },
    successMessage: {
      ...state.successMessage,
      [CARD_NAME]: "", //*
    },
  });

  HandleEmployeeLeaveRequest(controller, { ...params, action: "FETCH", activePage, filter });
};

/**========================================================================
 **                           Summary Work Menu
 *========================================================================**/

const HandleSummaryWork: Handler<ExtractAction<"Summary", "FETCH">> = async (
  controller,
  params
) => {
  const state = controller.getState();
};

/**========================================================================
 **                                APIS
 *========================================================================**/

const GetLeaveTypeList: Handler = async (controller, params) => {
  const state = controller.getState();

  const [resp, err] = await LeaveTypeList.list({
    apiToken: controller.apiToken,
    params: {},
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

const GetLeaveRequestList: Handler = async (controller, params) => {
  const state = controller.getState();

  const { filter, offset, limit } = params;

  const [resp, err] = await LeaveRequestList.list({
    apiToken: controller.apiToken,
    params: { ...filter, limit, offset },
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

const ApprovalLeaveRequest: Handler = async (controller, params) => {
  const state = controller.getState();

  const { requestId, data } = params;

  const [resp, err] = await LeaveRequestActionList.update({
    apiToken: controller.apiToken,
    pk: requestId,
    data,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

const GetWorkShiftsTemplateList: Handler = async (controller, params) => {
  const state = controller.getState();

  const { offset, limit, code_name, active_only } = params;

  return await HandleShiftsTemplateListApi(controller, {
    method: "list",
    apiParams: {
      offset,
      limit,
      code_name,
      active_only,
    },
  });
};

const SaveWorkShiftsTemplate: Handler = async (controller, params) => {
  const state = controller.getState();

  const { saveTemplate } = params;

  return await HandleShiftsTemplateListApi(controller, {
    method: "create",
    data: saveTemplate,
  });
};

const EditWorkShiftsTemplate: Handler = async (controller, params) => {
  const state = controller.getState();

  const { templateId, editTemplate } = params;

  return await HandleShiftsTemplateDetailApi(controller, {
    method: "update",
    pk: templateId,
    data: editTemplate,
  });
};

const DeleteWorkShiftsTemplate: Handler = async (controller, params) => {
  const state = controller.getState();

  const { templateId } = params;

  return await HandleShiftsTemplateDetailApi(controller, {
    method: "delete",
    pk: templateId,
  });
};

/**========================================================================
 **                               API Handlers
 *========================================================================**/

const HandleShiftsTemplateListApi: Handler<{
  method: "list" | "create";
  data?: Partial<WorkShiftTemplateSerializer>;
  apiParams?: any;
}> = async (controller, params) => {
  const commonParams = {
    apiToken: controller.apiToken,
    extra: {
      division: controller.data.division,
    },
  };

  const { method, data, apiParams } = params;

  const actionMethod = WorkShiftTemplateList[method];

  if (!actionMethod) return [null, new Error(`Invalid method: ${method}`)];

  let callParams: any = commonParams;

  if (method === "list") {
    callParams = { ...commonParams, params: apiParams };
  } else if (method === "create") {
    callParams = { ...callParams, data };
  }

  const [resp, err] = await actionMethod(callParams);

  if (err) return [null, err];

  return [resp, err];
};

const HandleShiftsTemplateDetailApi: Handler<{
  method: "retrieve" | "update" | "delete";
  pk: number;
  data?: Partial<WorkShiftTemplateSerializer>;
}> = async (controller, params) => {
  const { method, pk, data } = params;

  const commonParams = {
    apiToken: controller.apiToken,
    pk,
    extra: {
      division: controller.data.division,
    },
  };

  const actionMethod = WorkShiftTemplateDetail[method];

  if (!actionMethod) return [null, new Error(`Invalid method: ${method}`)];

  const callParams = method === "update" ? { ...commonParams, data } : commonParams;

  const [resp, err] = await actionMethod(callParams);

  if (err) return [null, err];

  return [resp, null];
};
